<!--The content below is only a placeholder and can be replaced.-->
<ngx-ui-loader></ngx-ui-loader>
<ngx-loading-bar [includeSpinner]=false height="3px" color="#dc291e"></ngx-loading-bar>
<router-outlet></router-outlet>
